export default __webpack_public_path__ + "static/manifold_w.b62e7bb641bf2fa8d7be277e60a919b9.png";